import React from 'react';
import Home from './components/homepage/Home';

const App = () => (
  <div>
    <Home />
  </div>
);
export default App;
